import { render, staticRenderFns } from "./DeleteReferent.vue?vue&type=template&id=145107c4&"
import script from "./DeleteReferent.vue?vue&type=script&lang=js&"
export * from "./DeleteReferent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports